export default __webpack_public_path__ + "static/media/mail.f21fbe92.svg";